import { useMutation } from '@tanstack/react-query';
import { type Tyrone_Prompt, gqlClient, graphql } from '@tyro/api';

const tyronePrompt = graphql(/* GraphQL */ `
  query tyrone_prompt($filter: Tyrone_Prompt!) {
    tyrone_prompt(filter: $filter) {
      conversationId
      result
    }
  }
`);

export function useTyronePrompt() {
  return useMutation({
    mutationFn: async (filter: Tyrone_Prompt) =>
      gqlClient.request(tyronePrompt, { filter }),
  });
}
